import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import {AgentRouteScoreModel} from "../../../../agents/angular/models/agent-route-score.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {TaskType} from "../../../../tasks/types/task.type";
import * as _ from "lodash";
import {QuantitySettingType} from "../../../../price-plan/types/quantitySetting.type";

require('./agents-route-score-expandable-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-agents-route-score-expandable-table-row',
  templateUrl: './agents-route-score-expandable-table-row.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentsRouteScoreExpandableTableRowComponent implements OnInit, OnChanges {

  @Input() agentRouteScore: any;
  @Input() expandedData: any;
  @Input() onAllowExpand: boolean;
  @Input() isBigScreen: boolean;
  @Output() onToggleExpand = new EventEmitter<string>();

  public tasksSequenceData: {
    details?: any;
    isCancelled?: boolean;
    isOutOfOrder?: boolean;
    number?: number;
  } [];

  public taskTypes: typeof TaskType = TaskType;
  public routeScorePieChartData: { segments: any[], innerTextConfiguration: any };

  constructor(@Inject('agentDialogService') private agentDialogService) {
  }

  ngOnInit() {

    if (!!this.agentRouteScore) {
      this.initTasksSequenceData();
      this.initPieChartTotalsWidgetSegments();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agentRouteScore && !changes.agentRouteScore.isFirstChange()) {
      this.initTasksSequenceData();
      this.initPieChartTotalsWidgetSegments();
    }
  }

  onViewAgentRouteTasks(tasks, routeName, plannedTasksOrder?: string[], actualTasksOrder?: string[]) {

    let orderedTasks;

    if (plannedTasksOrder && actualTasksOrder) {
      const tasksCopy = [...tasks];

      const stopoverPlannedTasksOrder = plannedTasksOrder.filter((taskId) => {
        const task = tasksCopy.find(t => t.id === taskId);
        if (task.taskType !== TaskType.Internal) {
          return taskId;
        }
      })

      stopoverPlannedTasksOrder.forEach((id, index) => {
        const task = tasksCopy.find(t => t.id === id);
        task.index = index;
      });

      orderedTasks = tasksCopy.sort((a, b) => actualTasksOrder.indexOf(a.id) - actualTasksOrder.indexOf(b.id));
    } else {
      orderedTasks = tasks;
    }

    this.agentDialogService.viewAgentRouteReportTasks(this.agentRouteScore.agentReference, orderedTasks, routeName);
  }

  getBundleIndicationWidth(tasksCount) {
    return 10 + ((tasksCount.toString().length || 0) * 5);
  }

  private initTasksSequenceData() {
    this.tasksSequenceData = [];

    this.agentRouteScore.actualTasksOrder?.forEach((taskId, actualTaskIndex) => {
      const taskData: {
        details?: any;
        isCancelled?: boolean;
        isOutOfOrder?: boolean;
        number?: number;
      } = {}
      taskData.details = this.agentRouteScore.routeTasks.find(t => t.id === taskId);
      taskData.isCancelled = this.agentRouteScore.canceledTasks.includes(taskId);

      const plannedTaskIndex = this.agentRouteScore.plannedTasksOrder.findIndex((id) => id === taskId);
      taskData.isOutOfOrder = plannedTaskIndex !== actualTaskIndex;

      taskData.number = plannedTaskIndex + 1;

      this.tasksSequenceData.push(taskData);
    })
  }

  private initPieChartTotalsWidgetSegments() {
    this.routeScorePieChartData = {
      innerTextConfiguration: undefined,
      segments: []
    };

    const averageScoreSegment = {
      value: Math.round(this.agentRouteScore.totalScore),
      color: this.routeScoreColor(this.agentRouteScore.totalScore)
    }

    this.routeScorePieChartData.innerTextConfiguration = {
      text: Math.round(this.agentRouteScore.totalScore) + '%',
      color: this.routeScoreColor(this.agentRouteScore.totalScore)
    }

    this.routeScorePieChartData.segments.push(averageScoreSegment);

    const averageScoreSegmentDiff = {
      value: 100 - Math.round(this.agentRouteScore.totalScore),
      color: this.addAlphaToRgb(this.routeScoreColor(this.agentRouteScore.totalScore), 0.3)
    }

    this.routeScorePieChartData.segments.push(averageScoreSegmentDiff);

  }

  private routeScoreColor(routeScore) {
    let color;
    switch (true) {
      case routeScore <= 60: {
        color = 'rgb(213, 36, 36)';
        break;
      }
      case routeScore > 60 && routeScore < 80: {
        color = 'rgb(221, 114, 32)';
        break;
      }
      case routeScore >= 80: {
        color = 'rgb(47, 133, 47)';
        break;
      }
      default: {
        color = 'rgb(47, 133, 47)';
        break;
      }
    }

    return color;
  }

  private addAlphaToRgb(rgb, alpha) {
    const [r, g, b] = rgb.match(/\d+/g).map(Number);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

}
